<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert } from '@Shelly/shelly-design-system';

	export let enabled: boolean = false;
</script>

{#if enabled}
	<Alert
		type="info"
		heading={$format('alert_night_mode_device_off_heading', {
			default: 'Night mode behavior when device is off',
		})}
		message={$format('alert_night_mode_device_off_message', {
			default:
				'During night mode active hours, if the device is turned off, the device behavior will be overridden with night mode settings.',
		})}
	/>
{/if}
